import { debounce, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/medical-groups/actions';
import medicalGroupsApi from 'src/services/api/medical-groups';

export function* list(action: any) {
  try {
    const response = yield call(medicalGroupsApi.list, action.filters);
    yield put(Creators.medicalGroupsListRequestSuccess(response.data));
  } catch (e) {
    let error = e.response;
    yield put(Creators.medicalGroupsListRequestError(error));
  }
}

export function* watchList() {
  yield debounce(6e2, Types.MEDICAL_GROUPS_LIST_REQUEST, list);
}

export default watchList;
